import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo.svg';
import { useAuth } from '../context/AuthContext';

function Navbar() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogoClick = () => {
    navigate('/dashboard');
  };

  const handleSignOut = async () => {
    await logout();
    navigate('/');
  };

  return (
    <nav className="w-full bg-gray-50 border-b border-gray-200 px-8 py-3 flex items-center justify-between shadow-sm z-10">
      {/* Logo */}
      <div className="flex items-center cursor-pointer" onClick={handleLogoClick}>
        <img src={logo} alt="Alice AI Recruiter Logo" className="h-9 w-auto" />
      </div>
      {/* Navigation Links */}
      <div className="flex items-center gap-8 text-base font-medium text-gray-700">
        <Link to="/dashboard" className="hover:text-orange-600 transition">Dashboard</Link>
        <Link to="/conversation" className="hover:text-orange-600 transition">Conversation</Link>
        <Link to="/contacts" className="hover:text-orange-600 transition">Contacts</Link>
        <Link to="/assistant" className="hover:text-orange-600 transition">Assistant</Link>
        <Link to="/people-search" className="hover:text-orange-600 transition">People Search</Link>
      </div>
      {/* Sign Out */}
      <button
        onClick={handleSignOut}
        className="ml-6 px-4 py-2 bg-white border border-gray-300 rounded-md text-gray-700 font-medium hover:bg-gray-100 transition"
      >
        Sign Out
      </button>
    </nav>
  );
}

export default Navbar;
